export default {"src":"/_next/static/media/staking_top_left_icon.3e9b092e.svg","height":49,"width":203,"blurWidth":0,"blurHeight":0};